<template>
  <BaseCard title="Historia Clínica" :noHover="true" :collapsible="true">
    <!-- TABS -->
    <div class="tabs-hc">
      <button class="tab-hc" :class="{ activo: tabActivo === 'historia' }" @click="tabActivo = 'historia'">
        Historia Clínica
      </button>
      <button class="tab-hc" :class="{ activo: tabActivo === 'comentarios' }" @click="tabActivo = 'comentarios'">
        Comentarios
      </button>
    </div>

    <!-- ── HISTORIA CLÍNICA ── -->
    <div v-if="tabActivo === 'historia'">
    <div class="actions-internal">
      <button v-if="expanded" class="btn-action btn-save" @click="agregar" :disabled="guardando">
        {{ guardando ? "Guardando…" : "Guardar" }}
      </button>
      <button class="btn-circle" @click="toggleEvolucion">
        {{ expanded ? "×" : "+" }}
      </button>
    </div>

    <div class="nueva" v-if="expanded">
      <div v-if="!editandoFecha" class="campo campo-fecha-nota">
        <label for="fecha-evolucion">Fecha de la evolución</label>
        <input type="date" id="fecha-evolucion" name="fecha-evolucion" v-model="fechaNota" class="input-fecha-nota" :max="hoyComoString()" />
      </div>
      <div class="nueva-header">
        <h4 class="nueva-title">
          {{ editandoFecha ? "Editar evolución" : "Nueva evolución" }}
        </h4>
        <button v-if="!editandoFecha" class="btn-small" @click="cambiarModo">
          {{ guiado ? "Texto libre" : "Modo guiado" }}
        </button>
      </div>

      <!-- MODO GUIADO: inputs por pregunta (ideal mobile) -->
      <div v-if="guiado" class="guiado">
        <!-- 1ra evolución: cuestionario completo + realizado/por realizar -->
        <!-- autocomplete="off" en TODOS los campos clínicos, a propósito: sin él, el navegador
             guarda en su historial de autocompletado lo que se escribe (alergias, medicación,
             diagnósticos) y lo sugiere después, incluso a otra persona en la misma computadora
             del consultorio. Es dato de salud: no debe quedar en el autofill del navegador. -->
        <div v-if="esPrimeraHistoria" class="guiado-grid">
          <div class="campo campo-full">
            <label for="hc-motivo">Motivo de consulta</label>
            <input
              v-model="form.motivo"
              id="hc-motivo" name="hc-motivo" autocomplete="off"
              placeholder="Ej: Limpieza, control..."
            />
          </div>

          <div class="campo">
            <label for="hc-diagnostico">¿Posee un diagnóstico médico?</label>
            <input v-model="form.diagnostico" id="hc-diagnostico" name="hc-diagnostico" autocomplete="off" placeholder="Sí/No - ¿Cuál?" />
          </div>
          <div class="campo">
            <label for="hc-medicacion">¿Toma alguna medicación?</label>
            <input v-model="form.medicacion" id="hc-medicacion" name="hc-medicacion" autocomplete="off" placeholder="Sí/No - ¿Cuál?" />
          </div>
          <div class="campo">
            <label for="hc-diabetes">¿Diabetes?</label>
            <input v-model="form.diabetes" id="hc-diabetes" name="hc-diabetes" autocomplete="off" placeholder="Sí/No" />
          </div>
          <div class="campo">
            <label for="hc-alergias">¿Alérgico a algún medicamento?</label>
            <input v-model="form.alergias" id="hc-alergias" name="hc-alergias" autocomplete="off" placeholder="Sí/No - ¿Cuál?" />
          </div>
          <div class="campo">
            <label for="hc-coagulacion">¿Problemas en la coagulación?</label>
            <input v-model="form.coagulacion" id="hc-coagulacion" name="hc-coagulacion" autocomplete="off" placeholder="Sí/No" />
          </div>
          <div class="campo">
            <label for="hc-embarazo">¿Está embarazada?</label>
            <input v-model="form.embarazo" id="hc-embarazo" name="hc-embarazo" autocomplete="off" placeholder="Sí/No/No aplica" />
          </div>

          <div class="campo">
            <label for="hc-sangrado">¿Le sangran las encías?</label>
            <input v-model="form.sangrado" id="hc-sangrado" name="hc-sangrado" autocomplete="off" placeholder="Sí/No" />
          </div>
          <div class="campo">
            <label for="hc-dolor">¿Presenta actualmente dolor?</label>
            <input v-model="form.dolor" id="hc-dolor" name="hc-dolor" autocomplete="off" placeholder="Sí/No - ¿Dónde?" />
          </div>
          <div class="campo">
            <label for="hc-sarro">¿Presenta sarro?</label>
            <input v-model="form.sarro" id="hc-sarro" name="hc-sarro" autocomplete="off" placeholder="Sí/No" />
          </div>
          <div class="campo campo-full">
            <label for="hc-realizado">Realizado</label>
            <textarea
              v-model="form.realizado"
              id="hc-realizado" name="hc-realizado" autocomplete="off"
              placeholder="Qué se realizó..."
              rows="6"
            ></textarea>
          </div>
          <div class="campo campo-full">
            <label for="hc-por-realizar">Por realizar</label>
            <textarea
              v-model="form.porRealizar"
              id="hc-por-realizar" name="hc-por-realizar" autocomplete="off"
              placeholder="Plan / próximos pasos..."
              rows="5"
            ></textarea>
          </div>
          <div class="campo">
            <span class="campo-label">Doctor/a:</span>
            <p class="doctor-nombre">{{ nombreDoctor }}</p>
          </div>
        </div>

        <!-- Evoluciones siguientes: solo seguimiento (realizado/próxima) -->
        <div v-else class="guiado-grid">
          <div class="campo campo-full">
            <label for="hc-realizado-seg">Realizado</label>
            <textarea
              v-model="form.realizado"
              id="hc-realizado-seg" name="hc-realizado-seg" autocomplete="off"
              placeholder="Qué se realizó..."
              rows="6"
            ></textarea>
          </div>
          <div class="campo campo-full">
            <label for="hc-proxima">Próxima</label>
            <textarea
              v-model="form.proxima"
              id="hc-proxima" name="hc-proxima" autocomplete="off"
              placeholder="Indicaciones / próxima consulta..."
              rows="4"
            ></textarea>
          </div>
          <div class="campo">
            <span class="campo-label">Doctor/a:</span>
            <p class="doctor-nombre">{{ nombreDoctor }}</p>
          </div>
        </div>
      </div>

      <!-- TEXTO LIBRE (fallback) -->
      <div v-else class="campo">
        <div class="campo-header-row">
          <span class="campo-label">Texto</span>
          <div class="herramientas-texto">
            <button class="btn-tool" @mousedown.prevent="deshacer" title="Deshacer">↩</button>
            <button class="btn-tool" @mousedown.prevent="aplicarNegrita" title="Negrita"><b>B</b></button>
            <div class="separator"></div>
            <div class="color-options">
              <div
                v-for="c in colores"
                :key="c"
                class="color-circle"
                :style="{ background: c }"
                @mousedown.prevent="aplicarColor(c)"
              ></div>
            </div>
          </div>
        </div>
        <EditorContent :editor="editor" class="editor-div" />
      </div>
    </div>

    <div v-if="notas && notas.length" class="evoluciones-header">
      <h4>Evoluciones</h4>
      <button class="btn-expandir" @click="pantallaCompleta = true" title="Ver en pantalla completa">
        ⛶ Pantalla completa
      </button>
    </div>
    <div v-if="notas && notas.length" class="lista-notas scroll-container">
      <div class="buscador-container">
        <input
          v-model="busqueda"
          type="search"
          id="buscar-notas"
          name="buscar-notas"
          autocomplete="off"
          placeholder="🔍 Buscar en historia clínica..."
          class="buscador-notas"
        />
      </div>

      <!-- <div class="ultima">
          <strong>Última evolución:</strong>
          <div>{{ formatearFecha(notas[notas.length-1].fecha) }} - {{ notas[notas.length-1].texto }}</div>
        </div> -->

      <div class="notas-list">
        <div v-for="n in notasFiltradas" :key="n.id || (n.fecha + n.texto)" class="nota-item">
          <div class="nota-header">
            <span class="nota-fecha">{{ formatearFecha(n.fecha) }}</span>
            <div class="nota-actions">
              <button
                v-if="esEditable(n)"
                class="btn-icon-action"
                @click="prepararEdicion(n)"
                title="Editar (solo disponible el día de carga)"
              >
                ✏️
              </button>
            </div>
          </div>
          <div class="nota-body" v-html="procesarTexto(n.texto)"></div>
        </div>
      </div>
    </div>

    <p v-else class="empty-msg">No hay notas registradas</p>

    <div class="footer-actions">
      <button class="btn-action" @click="imprimir">Imprimir</button>
    </div>
    </div><!-- fin historia -->

    <!-- ── COMENTARIOS ── -->
    <div v-if="tabActivo === 'comentarios'">
      <div class="actions-internal">
        <button v-if="expandedComentario" class="btn-action btn-save" @click="guardarComentario" :disabled="guardandoComentario">
          {{ guardandoComentario ? "Guardando…" : "Guardar" }}
        </button>
        <button class="btn-circle" @click="expandedComentario = !expandedComentario">
          {{ expandedComentario ? '×' : '+' }}
        </button>
      </div>

      <div v-if="expandedComentario" class="nueva">
        <textarea
          v-model="textoComentario"
          id="hc-comentario" name="hc-comentario" autocomplete="off"
          placeholder="Escribí tu comentario privado..."
          class="editor-comentario"
          rows="4"
        ></textarea>
      </div>

      <div v-if="comentarios && comentarios.length" class="lista-notas scroll-container" style="margin-top:12px">
        <div v-for="c in comentariosReversed" :key="c.fecha" class="nota-item">
          <div class="nota-header">
            <span class="nota-fecha">{{ formatearFecha(c.fecha) }}</span>
            <button
              class="btn-icon-action"
              @click="prepararEdicionComentario(c)"
              title="Editar"
            >✏️</button>
          </div>
          <div v-if="editandoComentarioFecha !== c.fecha" class="nota-body">{{ c.texto }}</div>
          <div v-else class="campo">
            <textarea v-model="textoComentarioEdicion" id="hc-comentario-edit" name="hc-comentario-edit" autocomplete="off" class="editor-comentario" rows="4"></textarea>
            <div style="display:flex;gap:8px;margin-top:6px">
              <button class="btn-action btn-save" @click="guardarEdicionComentario()">Guardar</button>
              <button class="btn-action" @click="editandoComentarioFecha = null">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
      <p v-else class="empty-msg">No hay comentarios registrados</p>
    </div><!-- fin comentarios -->

  </BaseCard>

  <!-- HISTORIA EN PANTALLA COMPLETA -->
  <Teleport to="body">
    <div v-if="pantallaCompleta" class="hc-full">
      <div class="hc-full-header">
        <h3 class="hc-full-title">Historia Clínica — {{ pacienteData.nombre }}</h3>
        <button class="hc-full-close" @click="pantallaCompleta = false" title="Cerrar">✕</button>
      </div>
      <div class="hc-full-buscador">
        <!-- autocomplete="off" a propósito: sin esto el navegador guardaría en su historial los
             fragmentos de texto clínico buscados, y los sugeriría después. -->
        <input
          v-model="busqueda"
          type="search"
          id="buscar-historia"
          name="buscar-historia"
          autocomplete="off"
          placeholder="🔍 Buscar en historia clínica..."
        />
      </div>
      <div class="hc-full-body">
        <div v-if="notasFiltradas.length" class="notas-list">
          <div v-for="n in notasFiltradas" :key="n.id || (n.fecha + n.texto)" class="nota-item">
            <div class="nota-header">
              <span class="nota-fecha">{{ formatearFecha(n.fecha) }}</span>
            </div>
            <div class="nota-body" v-html="procesarTexto(n.texto)"></div>
          </div>
        </div>
        <p v-else class="empty-msg">No hay evoluciones que coincidan.</p>
      </div>
    </div>
  </Teleport>

  <!-- SECCIÓN IMPRIMIBLE (Invisible en pantalla) -->
  <div class="printable-area">
    <div class="print-header">
      <h1>Historia Clínica</h1>
      <div class="datos-paciente">
        <p><strong>Paciente:</strong> {{ pacienteData.nombre }}</p>
        <p>
          <strong>Documento:</strong> {{ pacienteData.ci || "No registrado" }}
        </p>
        <p><strong>Fecha:</strong> {{ new Date().toLocaleDateString() }}</p>
      </div>
    </div>

    <div class="print-content">
      <!-- CASO 1: TIENE NOTAS -->
      <div v-if="notas && notas.length" class="print-notas">
        <div v-for="nota in (notas && notas.length ? notas.slice().reverse() : [])" :key="nota.id || (nota.fecha + nota.texto)" class="print-nota">
          <h4>Evolución del {{ formatearFecha(nota.fecha) }}</h4>
          <div class="print-pre" v-html="procesarTexto(nota.texto)"></div>
        </div>
      </div>
      <p v-else>No hay evoluciones registradas.</p>
    </div>
  </div>

  <!-- Modal de pago pendiente -->
  <ModalPagoPendiente 
    :mostrar="mostrarModalPago" 
    @cerrar="cerrarModalPago" 
  />

</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import ModalPagoPendiente from "@/components/ModalPagoPendiente.vue";
import { ref, computed, watch, nextTick, onMounted, onUnmounted } from "vue";
import { useRoute, onBeforeRouteLeave } from "vue-router";
import { usePacientesStore } from "@/stores/pacientes";
import { useUsuariosStore } from "@/stores/usuarios";
import { usePagoVerificacion } from "@/composables/usePagoVerificacion";
import { useToast } from "@/composables/useToast";
import { hayEdicionSinGuardar } from "@/composables/edicionPendiente";
import DOMPurify from "dompurify";
import { useEditor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Highlight from "@tiptap/extension-highlight";

const props = defineProps({
  notas: { type: Array, default: () => [] },
  comentarios: { type: Array, default: () => [] },
});

const route = useRoute();
const store = usePacientesStore();
const usuariosStore = useUsuariosStore();
const { mostrarModalPago, verificarPermisoPago, cerrarModalPago } = usePagoVerificacion();
const { error: toastError, success: toastSuccess } = useToast();

// Nombre del doctor/a con título según género
const nombreDoctor = computed(() => {
  const usuario = usuariosStore.usuarioActual;
  if (!usuario) return '';

  const genero = usuario.genero;
  let titulo;
  if (genero === 'femenino' || genero === 'Femenino' || genero === 'F') {
    titulo = 'Dra.';
  } else if (genero === 'masculino' || genero === 'Masculino' || genero === 'M') {
    titulo = 'Dr.';
  } else {
    titulo = 'Doctor(a)';
  }
  return `${titulo} ${usuario.nombre} ${usuario.apellido || ''}`.trim();
});

const tabActivo = ref("historia");
const texto = ref("");
const expanded = ref(false);
const guardando = ref(false);
const busqueda = ref("");
const pantallaCompleta = ref(false);

// Comentarios
const expandedComentario = ref(false);
// Aparte de `guardando` (evolución): sin esto, un doble toque duplicaba el comentario.
const guardandoComentario = ref(false);
const textoComentario = ref("");
const editandoComentarioFecha = ref(null);
const editandoComentarioId = ref(null);
const editandoComentarioTextoOriginal = ref("");
const textoComentarioEdicion = ref("");

const comentariosReversed = computed(() => props.comentarios.slice().reverse());

async function guardarComentario() {
  if (guardandoComentario.value) return; // ya se está guardando: no duplicar
  if (!textoComentario.value.trim()) return;
  if (store.modoOffline || !navigator.onLine) {
    toastError("Sin conexión: no se guardaron los cambios.");
    return;
  }
  const idPaciente = Number(route.params.id);
  try {
    guardandoComentario.value = true;
    const ok = await store.agregarComentario(idPaciente, textoComentario.value.trim());
    if (ok) {
      toastSuccess("✓ Comentario guardado");
      textoComentario.value = "";
      expandedComentario.value = false;
    }
    // Si falla, el store ya avisó y dejamos el texto para reintentar.
  } finally {
    guardandoComentario.value = false;
  }
}

function prepararEdicionComentario(c) {
  editandoComentarioFecha.value = c.fecha;
  editandoComentarioId.value = c.id || null;
  editandoComentarioTextoOriginal.value = c.texto;
  textoComentarioEdicion.value = c.texto;
}

async function guardarEdicionComentario() {
  if (!textoComentarioEdicion.value.trim()) return;
  if (store.modoOffline || !navigator.onLine) {
    toastError("Sin conexión: no se guardaron los cambios.");
    return;
  }
  const idPaciente = Number(route.params.id);
  const ok = await store.editarComentario(
    idPaciente,
    { id: editandoComentarioId.value, fecha: editandoComentarioFecha.value, texto: editandoComentarioTextoOriginal.value },
    textoComentarioEdicion.value.trim()
  );
  if (ok) {
    toastSuccess("✓ Comentario guardado");
    editandoComentarioFecha.value = null;
    editandoComentarioId.value = null;
    editandoComentarioTextoOriginal.value = "";
    textoComentarioEdicion.value = "";
  }
  // Si falla, el store ya avisó y dejamos el texto para reintentar.
}
// Editor de texto rico (Tiptap). Reemplaza al viejo contenteditable + execCommand, que era
// frágil en celular. La negrita, el resaltado por colores y deshacer se manejan con su API.
const editor = useEditor({
  extensions: [
    StarterKit,
    Highlight.configure({ multicolor: true }),
  ],
  content: "",
  onUpdate: ({ editor }) => {
    texto.value = editor.getHTML();
  },
});
onUnmounted(() => editor.value?.destroy());
const editandoFecha = ref(null);
const editandoNotaId = ref(null);
const editandoNotaTexto = ref("");
const guiado = ref(true);

function hoyComoString() {
  const hoy = new Date();
  const y = hoy.getFullYear();
  const m = String(hoy.getMonth() + 1).padStart(2, '0');
  const d = String(hoy.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
const fechaNota = ref(hoyComoString());


const form = ref({
  diagnostico: "",
  medicacion: "",
  diabetes: "",
  alergias: "",
  coagulacion: "",
  embarazo: "",
  motivo: "",
  sangrado: "",
  dolor: "",
  sarro: "",
  realizado: "",
  porRealizar: "",
  proxima: "",
});

const formatearFecha = (f) => new Date(f).toLocaleDateString();

function esDeHoy(valor) {
  // Acepta un Timestamp de Firestore (creadoEn nuevo, del servidor), un string ISO (notas
  // viejas y el reflejo local optimista) o null/undefined. Devuelve false si no hay fecha válida.
  let fecha;
  if (valor && typeof valor.toDate === "function") {
    fecha = valor.toDate(); // Firestore Timestamp
  } else if (valor) {
    fecha = new Date(valor); // string ISO / número
  } else {
    return false;
  }
  if (isNaN(fecha.getTime())) return false;
  const y = fecha.getFullYear();
  const m = String(fecha.getMonth() + 1).padStart(2, '0');
  const d = String(fecha.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}` === hoyComoString();
}

// Una evolución se puede editar solo el día en que se CARGÓ (no la fecha clínica elegida),
// para poder corregir aunque la evolución esté back-dateada. Usamos `creadoEn` (fecha real de
// carga); si no existe (evoluciones viejas), caemos a `fecha` para no cambiar su comportamiento.
function esEditable(nota) {
  return esDeHoy(nota.creadoEn || nota.fecha);
}

const pacienteData = computed(() => {
  const id = route.params.id;
  if (id && store.pacientes) {
    // Intentar buscar por ID (string o number)
    const p = store.pacientes.find((p) => p.id === Number(id));
    return p || { nombre: "", ci: "" };
  }
  return { nombre: "", ci: "" };
});

const notasFiltradas = computed(() => {
  let lista = props.notas.slice().reverse();
  if (!busqueda.value) return lista;
  return lista.filter((n) =>
    n.texto.toLowerCase().includes(busqueda.value.toLowerCase()),
  );
});

const esPrimeraHistoria = computed(
  () => !props.notas || props.notas.length === 0,
);

watch(guiado, async (val) => {
  // Al cambiar entre modo guiado / texto libre, mantener una plantilla coherente
  if (!expanded.value) return;
  if (editandoFecha.value) return; // edición: se mantiene el texto existente

  if (val === false) {
    // Al pasar a texto libre, generamos el texto a partir del formulario para evitar
    // inconsistencias (p.ej. que quede "POR REALIZAR" sin "REALIZADO").
    texto.value = esPrimeraHistoria.value
      ? buildTextoInicial()
      : buildTextoSeguimiento();
    actualizarEditorDesdeTexto();
  }
});

// Alterna entre modo guiado y texto libre. Al volver de texto libre a guiado, avisa si hay
// texto escrito a mano que se perdería (el modo guiado no puede reconstruirlo desde el texto).
function cambiarModo() {
  if (guiado.value === false) {
    const generado = esPrimeraHistoria.value ? buildTextoInicial() : buildTextoSeguimiento();
    const limpio = (s) => String(s || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    if (
      limpio(texto.value) !== limpio(generado) &&
      !window.confirm("Si volvés al modo guiado, se perderá lo que escribiste en texto libre. ¿Continuar?")
    ) {
      return;
    }
  }
  guiado.value = !guiado.value;
}

async function agregar() {
  if (!verificarPermisoPago()) return;

  // Al EDITAR una nota existente NO reconstruimos desde el formulario (estaría vacío y
  // borraría la nota): se guarda el texto tal cual quedó en el editor.
  if (guiado.value && !editandoFecha.value) {
    texto.value = esPrimeraHistoria.value
      ? buildTextoInicial()
      : buildTextoSeguimiento();
  }

  // No guardar evoluciones "fantasma" (solo la plantilla, sin datos). Al editar una nota
  // existente no aplica: ya tiene contenido cargado. En guiado miramos los campos; en texto
  // libre, el contenido más allá de los rótulos.
  if (!editandoFecha.value) {
    const vacia = guiado.value
      ? !Object.values(form.value).some((v) => String(v || "").trim() !== "")
      : !tieneContenidoEvolucion(texto.value);
    if (vacia) {
      toastError("La evolución está vacía. Escribí al menos qué se realizó antes de guardar.");
      return;
    }
  }

  if (!texto.value) return;
  // Online-only: si no hay conexión, NO guardamos y NO cerramos el formulario,
  // así la evolución escrita no se pierde. La doctora reintenta al volver la conexión.
  if (store.modoOffline || !navigator.onLine) {
    toastError("Sin conexión: no se guardaron los cambios.");
    return;
  }

  const idPaciente = Number(route.params.id);
  guardando.value = true;
  let guardado = false;
  try {
    if (editandoFecha.value) {
      guardado = await store.actualizarNota(
        idPaciente,
        { id: editandoNotaId.value, fecha: editandoFecha.value, texto: editandoNotaTexto.value },
        texto.value
      );
    } else {
      guardado = await store.agregarNota(idPaciente, texto.value, fechaNota.value);
    }
  } finally {
    guardando.value = false;
  }

  if (guardado) {
    toastSuccess("✓ Evolución guardada en la nube");
    toggleEvolucion(); // cierra y limpia el formulario SOLO si se confirmó el guardado
  }
  // Si no se guardó, el store ya avisó del error y dejamos el texto intacto para reintentar.
}

function prepararEdicion(nota) {
  texto.value = nota.texto;
  expanded.value = true;
  editandoFecha.value = nota.fecha;
  editandoNotaId.value = nota.id || null;   // editar por ID único (no por fecha)
  editandoNotaTexto.value = nota.texto;      // respaldo para notas viejas sin id
  guiado.value = false; // editar notas existentes en texto libre
  actualizarEditorDesdeTexto();
}

function toggleEvolucion() {
  expanded.value = !expanded.value;
  if (expanded.value) {
    guiado.value = true;
    fechaNota.value = hoyComoString();
    form.value = {
      diagnostico: "",
      medicacion: "",
      diabetes: "",
      alergias: "",
      coagulacion: "",
      embarazo: "",
      motivo: "",
      sangrado: "",
      dolor: "",
      sarro: "",
      realizado: "",
      porRealizar: "",
      proxima: "",
    };

    // Si el usuario elige texto libre, cargamos plantilla (por defecto seguimiento)
    // Texto libre: primera evolución con plantilla completa, luego plantilla seguimiento
    // (lo dejamos coherente con buildTextoInicial/buildTextoSeguimiento)
    texto.value = esPrimeraHistoria.value
      ? buildTextoInicial()
      : buildTextoSeguimiento();
    editandoFecha.value = null;
    editandoNotaId.value = null;
    editandoNotaTexto.value = "";
    actualizarEditorDesdeTexto();
  } else {
    // Si se cierra, limpiar
    texto.value = "";
    editandoFecha.value = null;
    editandoNotaId.value = null;
    editandoNotaTexto.value = "";
  }
}

function imprimir() {
  window.print();
}


async function actualizarEditorDesdeTexto() {
  await nextTick();
  if (!editor.value) return;
  // Las plantillas vienen como texto plano con saltos de línea; el resto ya es HTML.
  const html = /<[a-z][\s\S]*>/i.test(texto.value)
    ? texto.value
    : String(texto.value || "").replace(/\n/g, "<br>");
  editor.value.commands.setContent(html);
  // Reflejar en el modelo el HTML ya normalizado por el editor.
  texto.value = editor.value.getHTML();
}

const colores = ["#678AB2", "#27ae60", "#e74c3c", "#f39c12", "#9b59b6", "#1abc9c"];

function procesarTexto(t) {
  if (!t) return "";
  
  // Si parece HTML (del editor nuevo), lo sanitizamos antes de mostrarlo con v-html:
  // conserva el formato seguro (negrita, colores, resaltado, saltos) y elimina lo peligroso
  // (scripts, onerror, iframes, etc.). No toca la nota guardada: sanitiza solo al dibujar.
  if (/<[a-z][\s\S]*>/i.test(t)) {
    return DOMPurify.sanitize(t);
  }

  // --- COMPATIBILIDAD CON NOTAS ANTIGUAS (Texto plano + marcadores ==) ---
  // Escapar HTML para seguridad (evitar inyección de etiquetas no deseadas)
  let safe = t
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  // Reemplazar marcadores ==#color|texto== o ==texto== por etiqueta <mark>
  safe = safe.replace(/==((?:#[0-9a-fA-F]{3,6})\|)?(.*?)==/g, (match, colorPart, content) => {
    let bgColor = '#fff59d';
    let textColor = 'inherit';
    
    if (colorPart) {
      bgColor = colorPart.slice(0, -1); // quitar el pipe |
      textColor = 'black'; // colores oscuros, texto negro
    }
    return `<mark style="background-color: ${bgColor}; color: ${textColor}; padding: 0 2px; border-radius: 2px;">${content}</mark>`;
  });
  
  // Convertir saltos de línea a <br> y sanitizar por las dudas (el texto ya viene escapado).
  return DOMPurify.sanitize(safe.replace(/\n/g, '<br>'));
}

function aplicarColor(color) {
  // Resalta la selección con el color elegido (fondo). Con toggle: si ya estaba resaltado con
  // ese color, lo saca. Tiptap conserva la selección y funciona bien en celular.
  editor.value?.chain().focus().toggleHighlight({ color }).run();
}

function aplicarNegrita() {
  editor.value?.chain().focus().toggleBold().run();
}

function deshacer() {
  editor.value?.chain().focus().undo().run();
}

function buildTextoInicial() {
  const f = form.value;
  return `ANTECEDENTES GENERALES:
¿Posee un diagnóstico médico?: ${f.diagnostico || ""}
¿Toma alguna medicación?: ${f.medicacion || ""}
¿Diabetes?: ${f.diabetes || ""}
¿Es alérgico a algún medicamento?: ${f.alergias || ""}
¿Problemas en la coagulación?: ${f.coagulacion || ""}
¿Está embarazada?: ${f.embarazo || ""}

HISTORIA CLÍNICA ODONTOLÓGICA:
Motivo de consulta: ${f.motivo || ""}
¿Le sangran las encías?: ${f.sangrado || ""}
¿Presenta actualmente dolor?: ${f.dolor || ""}
¿Presenta sarro?: ${f.sarro || ""}

REALIZADO:
${f.realizado || ""}

POR REALIZAR:
${f.porRealizar || ""}

${nombreDoctor.value}`.trim();
}

function buildTextoSeguimiento() {
  const f = form.value;
  return `REALIZADO:
${f.realizado || ""}

PRÓXIMA:
${f.proxima || ""}

${nombreDoctor.value}`.trim();
}

// ¿El texto de la evolución tiene contenido real, más allá de los rótulos y el nombre del
// doctor? Se usa para no guardar evoluciones "fantasma" (solo la plantilla vacía) en texto
// libre. Trata <br>/</div>/</p> como saltos de línea y descarta las líneas que son solo un
// rótulo (terminan en ":") y el nombre del doctor.
function tieneContenidoEvolucion(t) {
  let s = String(t || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(div|p|h[1-6])>/gi, "\n")
    .replace(/<[^>]*>/g, "");
  if (nombreDoctor.value) s = s.split(nombreDoctor.value).join(" ");
  s = s
    .split("\n")
    .filter((linea) => {
      const l = linea.trim();
      if (!l) return false;        // líneas vacías
      if (/:$/.test(l)) return false; // rótulos sin respuesta (terminan en ":")
      return true;
    })
    .join(" ");
  return s.replace(/\s+/g, " ").trim() !== "";
}

// ── Aviso al salir/recargar si hay texto sin guardar ──────────────────────────
// Cubre el olvido de tocar "Guardar" y el querer salir con algo escrito sin guardar.
// El navegador muestra un cartel genérico (no se puede personalizar el texto), y en
// algunos celulares puede no dispararse: por eso además está la confirmación "✓ Guardado".
const hayCambiosSinGuardar = computed(() => {
  if (expandedComentario.value && textoComentario.value.trim()) return true;
  if (editandoComentarioFecha.value && textoComentarioEdicion.value.trim()) return true;
  if (expanded.value) {
    if (guiado.value) {
      return Object.values(form.value).some((v) => String(v || "").trim() !== "");
    }
    // En una evolución NUEVA, la plantilla sola (rótulos + nombre del doctor) no cuenta como
    // "cambios". Al editar una nota existente, cualquier contenido sí cuenta.
    if (editandoFecha.value) {
      return String(texto.value || "").replace(/<[^>]*>/g, "").trim() !== "";
    }
    return tieneContenidoEvolucion(texto.value);
  }
  return false;
});

function avisarSiHayCambiosSinGuardar(e) {
  if (hayCambiosSinGuardar.value) {
    e.preventDefault();
    e.returnValue = "";
  }
}

onMounted(() => window.addEventListener("beforeunload", avisarSiHayCambiosSinGuardar));
onUnmounted(() => window.removeEventListener("beforeunload", avisarSiHayCambiosSinGuardar));

// Mantener al día la banderita global para que la auto-actualización NO recargue la
// app mientras se está escribiendo algo sin guardar (clave en iPhone, donde el cartel
// "beforeunload" no se dispara). Al salir del componente, se limpia.
watch(hayCambiosSinGuardar, (hay) => { hayEdicionSinGuardar.value = hay; }, { immediate: true });
onUnmounted(() => { hayEdicionSinGuardar.value = false; });

// Navegación INTERNA (tocar Pacientes/Agenda, etc.): beforeunload no se dispara acá,
// así que usamos el guard del router. window.confirm funciona también en celular.
onBeforeRouteLeave(() => {
  if (hayCambiosSinGuardar.value) {
    return window.confirm("Tenés cambios sin guardar. ¿Salir sin guardar?");
  }
  return true;
});
</script>

<style scoped>
/* Tipografía base para toda la interfaz */
.scroll-container,
.nueva,
.campo,
.campo label,
.campo .campo-label,
.nueva-title,
.nota-item,
.btn-action,
.btn-small,
.btn-tool,
.buscador-notas,
.empty-msg {
  font-family: system-ui, sans-serif;
}

.scroll-container {
  max-height: min(55vh, 600px);
  overflow-y: auto;
  padding-right: 4px;
}

/* Encabezado "Evoluciones" + botón pantalla completa */
.evoluciones-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 4px;
}
.evoluciones-header h4 {
  margin: 0;
}
.btn-expandir {
  background: #eaf1ff;
  color: #678AB2;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.2s;
}
.btn-expandir:hover {
  background: #dbeafe;
}

/* Historia en pantalla completa */
.hc-full {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.hc-full-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  background: #678AB2;
  color: #fff;
}
.hc-full-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hc-full-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
}
.hc-full-close:hover {
  background: rgba(255, 255, 255, 0.35);
}
.hc-full-buscador {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.hc-full-buscador input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  box-sizing: border-box;
}
.hc-full-buscador input:focus {
  border-color: #678AB2;
}
.hc-full-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
}
.hc-full-body .nota-item {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}
.hc-full-body .nota-fecha {
  font-weight: 600;
  color: #111827;
  font-size: 15px;
}
.hc-full-body .nota-header {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.hc-full-body .nota-body {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #334155;
  font-size: 15px;
}

.buscador-notas {
  width: 100%;
  padding: 8px;
  margin-bottom: 12px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}
.buscador-notas:focus {
  border-color: #678AB2;
}

.actions-internal {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 12px;
}

.nueva {
  margin-top: 4px;
}

.nueva-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.nueva-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.guiado {
  background: #fff;
}

.guiado-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

/* (toolbar/antecedentes toggle removidos) */

.campo-full {
  grid-column: 1 / -1;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 6px; /* igual que "Editar Datos" */
  margin-bottom: 8px; /* igual que "Editar Datos" */
}

.campo-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.herramientas-texto {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-tool {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #374151;
  font-size: 14px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-tool:hover {
  background: #e5e7eb;
}

.color-options {
  display: flex;
  gap: 6px;
}

.color-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s;
}
.color-circle:hover { transform: scale(1.1); }

.separator {
  width: 1px;
  height: 16px;
  background: #e5e7eb;
}


/* .campo-label es para los rótulos que NO rotulan un campo de formulario ("Doctor/a:" rotula un
   <p>, y "Texto" rotula el editor Tiptap, que es un contenteditable). Un <label> ahí es HTML
   invalido y Chrome lo reporta; se usa <span> con el mismo aspecto. */
.campo label,
.campo .campo-label {
  font-size: 13px;
  color: #444;
  font-weight: 600;
}

.doctor-nombre {
  font-size: 14px;
  font-weight: 500;
  color: #678AB2;
  margin: 8px 0;
  padding: 8px 12px;
  background: #f0f4f8;
  border-radius: 6px;
  border-left: 3px solid #678AB2;
}

/* ✅ Mismo "skin" que los inputs de editar (pero aplicado a textarea) */
.campo input,
.campo textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  outline: none;
  font-size: 14px;
  box-sizing: border-box;
  margin: 0;
  transition: border-color 0.2s;
  font-family: system-ui, sans-serif;
}

.campo input:focus,
.campo textarea:focus {
  border-color: #678AB2;
  box-shadow: 0 0 4px rgba(103, 138, 178, 0.4);
}

.editor-div {
  width: 100%;
  box-sizing: border-box;
  min-height: 220px; /* más grande por defecto */
  padding: 8px 10px; /* igual que input en "Editar Datos" */
  border-radius: 8px; /* igual que input en "Editar Datos" */
  border: 1px solid #e6e6e6;
  background: #fff;
  outline: none;
  font-size: 14px; /* igual que la mayoría de inputs del proyecto */
  line-height: 1.6; /* más cómodo para escribir */
  overflow-y: auto;
  font-family: system-ui, sans-serif;
  margin: 0;
  white-space: pre-wrap; /* Respetar espacios y saltos */
}

.editor-div:focus,
.editor-div:focus-within {
  border-color: #678AB2;
  box-shadow: 0 0 4px rgba(103, 138, 178, 0.4); /* similar al modal */
}

/* Área editable interna de Tiptap */
.editor-div :deep(.ProseMirror) {
  min-height: 200px;
  outline: none;
}
.editor-div :deep(.ProseMirror p) {
  margin: 0 0 0.4em;
}
.editor-div :deep(.ProseMirror p:last-child) {
  margin-bottom: 0;
}

/* Resaltados (marcas): Tiptap solo pone el fondo; le damos texto legible y el mismo estilo
   redondeado de siempre. Las notas viejas que ya traen color en línea, mandan ellas. */
:deep(mark) {
  color: #000;
  padding: 0 2px;
  border-radius: 2px;
}

/* Mobile: más "aire" y altura inicial mayor */
@media (max-width: 480px) {
  .editor-div {
    min-height: 240px;
    padding: 10px 12px;
    font-size: 16px; /* mejor para escribir en celular */
  }

  .campo input,
  .campo textarea {
    font-size: 16px; /* mejor para escribir en celular */
  }
}

/* Tablet / Desktop: un poco más de altura y tipografía estable */
@media (min-width: 768px) {
  .editor-div {
    min-height: 260px;
  }
}

.btn-undo {
  background: #eef2ff;
  color: #1e40af;
}

.btn-undo:hover {
  filter: brightness(0.98);
}

.notas-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nota-item {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nota-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 8px;
  margin-bottom: 4px;
}

.nota-fecha {
  font-weight: 600;
  color: #111827;
  font-size: 14px;
}

.nota-body {
  white-space: pre-wrap;
  line-height: 1.5;
  color: #334155;
  font-size: 14px;
}

.nota-actions {
  display: flex;
  gap: 8px;
}

.btn-icon-action {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
}
.btn-icon-action:hover {
  background: #e2e8f0;
}
.btn-icon-action.btn-danger {
  color: #ef4444;
}
.btn-icon-action.btn-danger:hover {
  background: #fee2e2;
}

.btn-action {
  background: #eaf1ff;
  color: #678AB2;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.2s;
}

/* Mientras guarda: además de estar deshabilitado, que SE VEA deshabilitado. */
.btn-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-action:hover {
  background: #dbeafe;
}

.footer-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.btn-save {
  background: #27ae60; /* Verde para guardar */
  color: white;
}

.btn-circle {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: #678AB2;
  color: white;
  border: none;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(103, 138, 178, 0.35);
}

.btn-small {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #678AB2;
  font-weight: 600;
}

.empty-msg {
  color: #9ca3af;
  font-style: italic;
  text-align: center;
  margin: 16px 0;
}

/* ── TABS ── */
.tabs-hc {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 0;
}

.tab-hc {
  padding: 6px 14px;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;
}

.tab-hc.activo {
  color: #678AB2;
  border-bottom-color: #678AB2;
}

.tab-hc:hover:not(.activo) {
  color: #678AB2;
}

/* ── EDITOR COMENTARIOS ── */
.editor-comentario {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  font-family: system-ui, sans-serif;
  resize: vertical;
  line-height: 1.5;
}

.editor-comentario:focus {
  outline: none;
  border-color: #678AB2;
  box-shadow: 0 0 0 2px rgba(103, 138, 178, 0.15);
}

/* Estilos específicos para mejorar el encabezado en la ficha */
:deep(.card) {
  padding: 0 !important;
  overflow: hidden;
}

:deep(.card-header) {
  background-color: #f8f9fa;
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 0 !important;
}

:deep(.card-body) {
  padding: 16px;
}

/* ESTILOS DE IMPRESIÓN */
/* ESTILOS DE IMPRESIÓN */
.printable-area {
  display: none;
}

@media print {
  /* Ocultar todo el contenido de la página */
  :global(body *) {
    visibility: hidden;
  }

  /* Mostrar solo el área imprimible y sus hijos */
  .printable-area,
  .printable-area * {
    visibility: visible;
  }

  .printable-area {
    display: block !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    z-index: 9999;
    padding: 20px;
  }

  .print-header {
    border-bottom: 2px solid #000;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }

  .print-header h1 {
    text-align: center;
    font-size: 22px;
    margin-bottom: 15px;
    color: #000;
  }

  .datos-paciente {
    font-size: 14px;
    color: #000;
  }

  .datos-paciente p {
    margin: 4px 0;
    color: #000;
  }

  .print-content {
    margin-top: 20px;
  }

  .print-notas {
    margin: 0;
  }

  .print-nota {
    margin-bottom: 30px;
    page-break-inside: avoid;
    color: #000;
  }

  .print-nota h4 {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #000;
    font-weight: 600;
  }

  .print-pre {
    white-space: pre-wrap;
    font-family: 'Courier New', Courier, monospace;
    font-size: 13px;
    line-height: 1.8;
    color: #000;
    margin: 0;
    padding: 10px 0;
  }

  /* Ocultar elementos de UI */
  .btn-action,
  .btn-circle,
  .btn-icon-action,
  .buscador-notas,
  .nota-actions,
  .actions-internal,
  .footer-actions {
    display: none !important;
  }
}

.campo-fecha-nota {
  margin-bottom: 12px;
}

.input-fecha-nota {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
  font-family: system-ui, sans-serif;
  transition: border-color 0.2s;
}

.input-fecha-nota:focus {
  outline: none;
  border-color: #678AB2;
  box-shadow: 0 0 4px rgba(103, 138, 178, 0.4);
}

</style>
